var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Field',{on:{"save":_vm.save},scopedSlots:_vm._u([{key:"view",fn:function(){return [_c('a',{attrs:{"href":'tel:'+_vm.mobile}},[_vm._v(_vm._s(_vm.mobile))])]},proxy:true},{key:"edit",fn:function(){return [_c('v-text-field',{model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }